import React, { useEffect, useRef, useState } from "react";
import { Text } from "./../../Components/Text";
import { RadioButton, RadioButtonGroup } from "./../../Components/RadioButton";
import { styled } from "@linaria/react";
import { themeDefault } from "src/theme-revamp";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import { css } from "@linaria/core";
import { useHistory } from "react-router-dom";
import Accordion from "@components/_Revamp/Accordion";
import Bullet from "@components/_Revamp/Bullet";
import { calculateSpacer } from "@utils/spaceCalculation";
import { scrollToRef } from "@utils/scrollScript";
import { ROUTE_PATH } from "@static/route-paths";
import AdviserValidater from "./AdviserValidater";
import {
  FinancialAdviser,
  updateAgentCode,
  updateAgentName,
  updateAgentResponce,
  updateAutoAssignAgent,
} from "@redux/slices/SHIELD_STARTER/step4Slice";
import MainContainer from "@pages/ShieldStarter/Components/Container";
import { trackOnLoad } from "@pages/ShieldStarter/Helpers/dataAnalyticsHelpers";
import { SCREEN_SIZE } from "@static/screen-size";
import { setInvalidArcCodeFromUrl } from "@redux/slices/loadingSlice";

const FormContainer = styled.div<FormHeaderContainerProps>`
  opacity: 0;
  -webkit-transition: opacity 0.5s ease-in;
  -moz-transition: opacity 0.5s ease-in;
  -o-transition: opacity 0.5s ease-in;
  -ms-transition: opacity 0.5s ease-in;
  transition: opacity 0.5s ease-in;
  transition: all 0.2s ease;
  flex-direction: column;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  /* margin: 50px auto 0px auto; */
  border-radius: 24px;
  padding: 24px;
  background-color: #fff;
`;

const AdviserValidaterContainer = styled.div<FormHeaderContainerProps>`
  opacity: 0;
  -webkit-transition: opacity 0.5s ease-in;
  -moz-transition: opacity 0.5s ease-in;
  -o-transition: opacity 0.5s ease-in;
  -ms-transition: opacity 0.5s ease-in;
  transition: opacity 0.5s ease-in;
  transition: all 0.2s ease;
`;

const FormHeaderContainer = styled.div<FormHeaderContainerProps>`
  display: block;
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "unset")};
  margin: ${(props) => (props.margin ? props.margin : "unset")};
  margin-bottom: 24px;
  @media screen and (min-width: 768px) {
    margin-bottom: 16px;
  }
`;

const FormLinkContainer = styled.div`
  display: block;
  margin: 0;
  margin-bottom: 64px;
  padding: 0;
  cursor: pointer;
  @media screen and (min-width: 768px) {
  }
`;

const FormHeaderTitleContainer = styled.div<FormHeaderTitleContainerProps>`
  display: block;
  margin-bottom: 16px;
  @media screen and (min-width: 768px) {
    margin: 0 ${(props) => props.marginHorizontal} 16px;
  }
`;

export interface FormHeaderContainerProps {
  margin?: string;
  maxWidth?: string;
}

export interface FormContainerProps {
  margin?: string;
}

export interface FormHeaderTitleContainerProps {
  marginHorizontal: string;
  maxWidth?: string;
}

const FormLinkCss = css`
  font-style: normal;
  font-weight: 600;
  text-decoration: underline;
  color: #883e89;
`;

const FormContentContainer = styled.div<FormHeaderContainerProps>`
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "unset")};
  margin: ${(props) => (props.margin ? props.margin : "0 20px;")};
  width: 100%;
  display: block;
  /* padding-bottom: 30px; */
  @media screen and (max-width: 768px) {
  }
`;

const AccordionContainer = styled.div`
  /* max-width: 327px; */
  margin-top: 64px;
  padding-bottom: 36px;
`;

const ButtonLabel = styled.p`
  font-weight: 600;
`;

const container_default_css = css`
  margin-bottom: 0px;
`;

const title_default_css = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  @media screen and (max-width: 768px) {
    width: unset;
    font-size: 16px;
  }
`;

const accordionArgs = {
  title:
    "Things to note when we assign a Financial Adviser Representative to you:",
  theme: themeDefault,
  className: container_default_css,
  titleClassName: title_default_css,
  headerPadding: "24px 24px 24px 0",
  titleFontSize: 14,
  isExpanded: true,
  showBottomLine: true,
  showHeaderLine: true,
  bottomLineColor: "#c4c4c4",
  bottomLineThickness: "1px",
  contentMarginLeft: "0px",
  contentMarginRight: "0px",
  bottomLineClassName: "margin:10px",
  headerBackgroundColor: "#F4F6F9",
  showHeaderBackground: true,
};

export const Adviser = (props: any) => {
  const history = useHistory();
  const dispatch = useAvivaDispatch();
  const autoAssignAgent = useAvivaSelector(
    (state) => state.shieldStarterStep4.autoAssignAgent
  );
  const currentAgentCode = useAvivaSelector(
    (state) => state.shieldStarterStep4.agentCode
  );
  const campaignDetail = useAvivaSelector(
    (state) => state.loading.campaignDetail
  );
  const agentCodeFromUrl = useAvivaSelector(
    (state) => state.shieldStarterStep4.agentCodeFromUrl
  );
  const isInvalidAgentCode = useAvivaSelector(
    (state) => state.loading.isInvalidArcCodeFromUrl
  );
  const PolicyDetailRef = useRef<null | HTMLDivElement>(null);
  const ValidaterFormRef = useRef<null | HTMLDivElement>(null);
  const SpacerRef = useRef<null | HTMLDivElement>(null);
  const [isAgentAvailable, setIsAgentAvailbale] = useState(false);
  const [screenSize, setScreenSize] = useState(window.innerWidth);

  const detectScreenWidth = () => {
    setScreenSize(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", detectScreenWidth);
    return () => {
      window.removeEventListener("resize", detectScreenWidth);
    };
  }, [screenSize]);

  useEffect(() => {
    if((agentCodeFromUrl || isInvalidAgentCode)&& (autoAssignAgent === "" || autoAssignAgent === FinancialAdviser.USER_PREFERRED )) openAgentValidation()
    if( autoAssignAgent === FinancialAdviser.USER_PREFERRED ){
      openAgentValidation()
    }
    if (PolicyDetailRef.current) {
      PolicyDetailRef.current.style.opacity = "1";
    }
  }, [agentCodeFromUrl, isInvalidAgentCode]);

  useEffect(() => {
    trackOnLoad("sss_financial_adviser_requirement_page");
  }, []);

  const clearAgentData = () => {
    dispatch(updateAgentCode(""));
    dispatch(updateAgentName(""));
    dispatch(updateAgentResponce({}));
  };

  const openAgentValidation = () => {
    dispatch(updateAutoAssignAgent(FinancialAdviser.USER_PREFERRED));
    setIsAgentAvailbale(true);

    setTimeout(() => {
      if (ValidaterFormRef && ValidaterFormRef.current) {
        let unit = -26;
        screenSize < SCREEN_SIZE.mobilesUp && (unit = 94);
        screenSize > SCREEN_SIZE.mobilesUp &&
          screenSize < SCREEN_SIZE.mobileSteper &&
          (unit = -64);
        const elementOffSetTop = ValidaterFormRef.current.offsetTop;
        calculateSpacer(ValidaterFormRef, SpacerRef, false);
        const top = window.pageYOffset || document.documentElement.scrollTop;
        scrollToRef(
          document.documentElement,
          "scrollTop",
          unit,
          top,
          elementOffSetTop,
          300,
          true
        );
        ValidaterFormRef.current.style.opacity = "1";
      }
    }, 100);
  };

  useEffect(() => {
    if (campaignDetail) history.push(ROUTE_PATH.SHIELD_STARTER_REVIEW);
    if (currentAgentCode) openAgentValidation();
  }, [currentAgentCode, campaignDetail]);

  return (
    <MainContainer
      step={4}
      backButtonPath={ROUTE_PATH.SHIELD_STARTER_DECLARATION}
    >
      <FormContainer ref={PolicyDetailRef} margin={"0 auto"}>
        <FormHeaderContainer maxWidth={"611px"} margin={"0 auto"}>
          <FormHeaderTitleContainer marginHorizontal={"50px"}>
            <Text variant="title" align="center">
              {
                "Do you need a Financial Adviser \n Representative to service this policy?"
              }
            </Text>
          </FormHeaderTitleContainer>
          <FormLinkContainer>
            <Text variant="base" align="center" textClass={FormLinkCss}>
              <a onClick={openAgentValidation}>
                I want to assign my own adviser
              </a>
            </Text>
          </FormLinkContainer>
          <RadioButtonGroup
            name="agentSelection"
            theme={themeDefault}
            onChange={(event: any) => {
              dispatch(updateAutoAssignAgent(event.target.value));
              dispatch(setInvalidArcCodeFromUrl(false))
              clearAgentData();
              history.push(ROUTE_PATH.SHIELD_STARTER_REVIEW);
            }}
            activeType={"fill"}
            value={autoAssignAgent}
            widthIcon={false}
            isHoverAlt
          >
            <RadioButton
              padding="14px 10px"
              justifyContent="center"
              value={FinancialAdviser.NO_AGENT}
            >
              <ButtonLabel>No, I do not need an adviser</ButtonLabel>
            </RadioButton>
            <RadioButton
              padding="14px 10px"
              justifyContent="center"
              value={FinancialAdviser.ARISTOTLE}
            >
              <ButtonLabel>Yes, assign an adviser to me</ButtonLabel>
            </RadioButton>
          </RadioButtonGroup>
        </FormHeaderContainer>
      </FormContainer>
      <FormContentContainer margin={"0 auto"}>
        <AccordionContainer>
          <Accordion {...accordionArgs}>
            <div style={{ paddingBottom: "20px" }}>
              <Bullet>
                <Text variant="base">
                  If you are an existing Singlife customer, we’ll assign the
                  latest active representative, either from Singapore Life Ltd.
                  or from our distribution partners, who had sold our plans to
                  you.
                </Text>
              </Bullet>
              <Bullet>
                <Text variant="base">
                  If you are a new customer of Singlife or don’t have an active
                  representative who have sold a Singlife plan to you, we’ll
                  assign a dedicated Singlife Relationship Consultant.
                </Text>
              </Bullet>
            </div>
            <Text variant="base" padding="0 0 20px">
              Once you’ve completed your purchase, we’ll email you the details
              of the assigned financial adviser representative who will be
              servicing your policy.
            </Text>
          </Accordion>
        </AccordionContainer>
      </FormContentContainer>
      {isAgentAvailable && (
        <AdviserValidaterContainer ref={ValidaterFormRef}>
          <AdviserValidater />
        </AdviserValidaterContainer>
      )}
      <div ref={SpacerRef}></div>
    </MainContainer>
  );
};

export default Adviser;
